import { DonateFormContext } from "@components/donate/DonateV3/PaymentProcess/useDonateFormContext";
import {
  DonateFormType,
  paymentFlowOptionToPaymentMethodMap,
} from "@components/donate/DonateV3/types";
import { useEffect } from "react";
import { UseFormReturn } from "react-hook-form";

import {
  DonationFlowPaymentOption,
  PaymentMethod,
} from "@every.org/common/src/entity/types";

interface UpdatePaymentMethodArgs {
  paymentOption: DonationFlowPaymentOption;
  form: UseFormReturn<DonateFormType>;
  formContext: DonateFormContext;
  creditsOnly?: boolean;
}

export function useSyncPaymentMethod({
  paymentOption,
  form,
  formContext,
  creditsOnly,
}: UpdatePaymentMethodArgs): void {
  useEffect(() => {
    if (creditsOnly) {
      form.setValue("paymentMethod", PaymentMethod.CREDITS);
    } else {
      form.setValue(
        "paymentMethod",
        paymentFlowOptionToPaymentMethodMap[paymentOption]
      );
    }
    formContext.setCurrentPaymentOption(paymentOption);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentOption, creditsOnly]);
  return;
}
